'use client'
import React, { useEffect, useState } from 'react'
import { TextTypes } from '../../../../types'
import { Text } from '../../Text'

export interface SpinnerProps extends React.HTMLAttributes<HTMLDivElement> {
    percentage?: number
}

const DEFAULT_PERCENTAGE = 40

export const Spinner = ({ percentage, ...props }: SpinnerProps) => {
    const [strokeDashoffset, setStrokeDashoffset] = useState(0)
    const circumference = 10 * 2 * Math.PI

    useEffect(() => {
        if (percentage) {
            setStrokeDashoffset(circumference - (percentage / 100) * circumference)
        } else {
            setStrokeDashoffset(circumference - (DEFAULT_PERCENTAGE / 100) * circumference)
        }
    }, [percentage])

    return (
        <span {...props} className={`spinner inline-flex shrink-0 items-center ${props?.className}`}>
            <span className="transform -rotate-90 ">
                <svg className={`w-6 h-6 ${!percentage ? 'animate-spin' : ''}`} height="24" width="24">
                    <circle
                        className="text-shade-opacity-200"
                        stroke="currentColor"
                        fill="transparent"
                        r="10"
                        cx="12"
                        cy="12"
                    />
                    <circle
                        className="text-accent-600"
                        strokeWidth="2"
                        strokeDasharray={circumference}
                        strokeDashoffset={strokeDashoffset}
                        stroke="currentColor"
                        fill="transparent"
                        r="10"
                        cx="12"
                        cy="12"
                    />
                </svg>
            </span>
            {percentage && percentage >= 0 && percentage <= 100 && (
                <Text type={TextTypes.SMALL_TEXT} className="text-text-tertiary ml-2">{`${percentage}%`}</Text>
            )}
        </span>
    )
}
